import { render, staticRenderFns } from "./auto-form.vue?vue&type=template&id=484c10e3&"
import script from "./auto-form.vue?vue&type=script&lang=js&"
export * from "./auto-form.vue?vue&type=script&lang=js&"
import style0 from "./auto-form.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports